import { render, staticRenderFns } from "./SistemaTaxacaoSelect.vue?vue&type=template&id=7bfa3b1b"
import script from "./SistemaTaxacaoSelect.vue?vue&type=script&lang=js"
export * from "./SistemaTaxacaoSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports